import React, { useEffect, useRef, useState } from "react";

import styled from "styled-components/macro";

import API from "Signups/FamilyRegistration/API";

import FnrIcon from "UI/FnrIcon";
import FnrLoadingBricks from "UI/FnrLoadingBricks2";

export default function DndDeleteButton({
  status,
  statusID,
  triggerDeleteConfirmation,
  setError,
  buttonRef,
  setStatusInUse,
}) {
  const [loading, setLoading] = useState(false);

  // The initial draft of this component assumed using an api call to find out if the status was in use
  // This may be changing and just having the information in the data instead
  const handleClick = () => {
    setLoading(true);
    setError(null);
    API.checkStatusInUse({ statusID })
      .post()
      .then((res) => {
        setStatusInUse(res.statusInUse);
      })
      .catch((err) => {
        setError("Hmm. Something went wrong. Please close this and try again.");
      })
      .finally(() => {
        setLoading(false);
        triggerDeleteConfirmation();
      });
  };

  return (
    <div style={{ position: "relative" }}>
      <FnrLoadingBricks loading={loading} size={14}>
        <IconContainer ref={buttonRef} onClick={handleClick}>
          <FnrIcon far fa-trash-alt style={{ color: "#B0B0B0" }} />
        </IconContainer>
      </FnrLoadingBricks>
    </div>
  );
}

const IconContainer = styled.div`
  cursor: pointer;
`;
